import { useEffect, useReducer } from 'react';

import { actions, emailPreferencesReducer, initialState } from '../Store';
import { getEmailPreferences, updateEmailPreferences } from '../../../services/mailist';

const useEmailPreferences = () => {
  const [{ emailPreferences }, stateDispatch] = useReducer(emailPreferencesReducer, initialState());

  const updatePreference = (value) => updateEmailPreferences(value)
    .then((response) => {
      if (response.error && response.error.code) {
        throw response.error;
      }
      return stateDispatch(actions.updateEmailPreference(value));
    })
    .catch((error) => {
      stateDispatch(actions.updateEmailPreferencesFail(error));
      throw error;
    });

  useEffect(() => {
    stateDispatch(actions.getEmailPreferences());
    getEmailPreferences()
      .then((data) => stateDispatch(actions.getEmailPreferencesSuccess(data)))
      .catch((error) => stateDispatch(actions.getEmailPreferencesFail(error)));
  }, []);

  return [emailPreferences, updatePreference];
};

export default useEmailPreferences;
